'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');
var TrashListView = require('../partials/trash-list');

var template = require('../../templates/layout/trash.hbs');

var TrashLayout = LayoutView.extend({
    template: template,

    className: 'settings settings-trash', //@todo move to own css file

    ui: {
        emptyTrash:  '[data-action="empty-trash"]',
        subline:  'header .subline',
    },

    events: {
        'click @ui.emptyTrash': 'onEmptyTrash',
    },

    regions: {
        trashListRegion: '.trash-list-region',
    },

    collectionEvents: {
        'reset add remove change sync': 'updateUi',
    },

    // initialize: function(options) {
    //     LayoutView.prototype.initialize.apply(this, arguments);

    //     this.listenTo(this.collection, 'reset add remove change sync', function() {
    //         this.updateUi();
    //     });
    // },

    /**
     * Is called, when the trash should be cleared
     * @param {object} event The click event
     */
    onEmptyTrash: function(event) {
        var $button = $(event.currentTarget);
        $button.addClass('is-loading');

        this.collection.emptyTrash(function() {
            $button.removeClass('is-loading');
            Messenger().success({
                message: App.t('settings::trash:response:trash-cleared-success'),
            });
        }, function(data) {
            $button.removeClass('is-loading');
            Messenger().error({
                message: App.t('settings::trash:response:trash-cleared-error'),
            });
        });
    },

    onShow: function(){
        var scrollContainer = $('#content');

        this.trashListRegion.show(new TrashListView({
            collection: this.collection,
            lazyRender: true,
            lazyRenderScrollEl: scrollContainer,
            scrollContainer: scrollContainer,
            lazyRenderPreviousPageThreshold: '20rem',
        }));
    },

    updateUi: function() {
        this.ui.emptyTrash.prop('disabled', this.collection.length === 0);
        this.ui.subline.html(App.t('settings::trash:subline:item-count', this.collection.length));
    },
});

module.exports = TrashLayout;